import { apiClient } from './apiClient';

export const teamService = {
  // Get all team members
  async getTeamMembers() {
    return apiClient.get(`/api/cmms/team`);
  },

  // Get active team members
  async getActiveMembers() {
    return apiClient.get(`/api/cmms/team/active`);
  },

  // Get team members by role
  async getMembersByRole(role) {
    return apiClient.get(`/api/cmms/team/role/${role}`);
  },

  // Get single team member by ID
  async getMemberById(id) {
    return apiClient.get(`/api/cmms/team/${id}`);
  },

  // Create new team member
  async createMember(data) {
    const payload = {
      email: data.email,
      password: data.password,
      firstName: data.firstName || null,
      lastName: data.lastName || null,
      phone: data.phone || null,
      role: data.role,
      employeeId: data.employeeId || null,
      department: data.department || null,
      jobTitle: data.jobTitle || null,
      assignedBranchIds: data.assignedBranchIds || null,
      team: data.team || null
    };
    return apiClient.post(`/api/cmms/team`, payload);
  },

  // Update team member
  async updateMember(id, data) {
    const payload = {
      firstName: data.firstName || null,
      lastName: data.lastName || null,
      phone: data.phone || null,
      role: data.role || null,
      employeeId: data.employeeId || null,
      department: data.department || null,
      jobTitle: data.jobTitle || null,
      assignedBranchIds: data.assignedBranchIds || null,
      team: data.team || null,
      isActive: data.isActive !== undefined ? data.isActive : null
    };
    return apiClient.put(`/api/cmms/team/${id}`, payload);
  },

  // Update team member status
  async updateMemberStatus(id, isActive) {
    return apiClient.put(`/api/cmms/team/${id}/status?isActive=${isActive}`);
  },

  // Delete team member
  async deleteMember(id) {
    return apiClient.delete(`/api/cmms/team/${id}`);
  }
};
